import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./Customer.css";
import bacteria from "../images/bacteria.png";
import time from "../images/time.png";
import logo from "../images/logo.png"; //

const SOCKET_SERVER_URL_API = process.env.REACT_APP_SOCKET_SERVER_URL_API;

function CustomerHello() {
  const { deviceId } = useParams();
  const [deviceData, setDeviceData] = useState(null);
  const [loading, setLoading] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}.${month}.${day}`;
  };

  useEffect(() => {
    if (!deviceId) return;
    const fetchAverageData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${SOCKET_SERVER_URL_API}/bacteria-log/average/${deviceId}`
        );
        setDeviceData(response.data);
      } catch (error) {
        console.error("Error fetching average eLuxData:", error);
        setDeviceData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchAverageData();
  }, [deviceId]);

  const progressPercentage =
    deviceData && deviceData.progress === "In Progress"
      ? deviceData.count === 0
        ? 0
        : Math.min(Math.round((deviceData.count / 72) * 100), 100)
      : null;

  return (
    <div className="customer-page">
      <div className="device-detail-container">
        <div className="water-background">

          {/* 🔷 Brand Header */}
          <header className="brand-header" aria-label="Brand header">
            <div className="brand-left">
              <img
                src={logo}
                alt="Citispring logo"
                className="brand-logo"
                width={40}
                height={40}
                loading="eager"
                decoding="async"
              />
              <div className="brand-text">
                <div className="brand-title">Citispring Bactest</div>
                <div className="brand-subtitle"></div>
              </div>
            </div>
            {/* Optional right slot for actions or environment badge */}
            <div className="brand-right">
              {/* <span className="env-badge">Production</span> */}
            </div>
          </header>

          {/* Title keeps the same theme */}
          <h2 className="title">{deviceId ? "Bacteria Detection" : ""}</h2>

          {/* General landing view when NO deviceId */}
          {!deviceId ? (
            <div className="info-layout">
              <div className="detection-box" style={{ padding: "24px" }}>
                <h1 style={{ margin: 0 }}>Welcome</h1>
                
              </div>

              <br />

              <div className="reference-container">
                <h4>About this Dashboard</h4>
                <div className="reference-labels">
                  <span>Real-time IoT data</span>
                  <span>Safe/Unsafe detection</span>
                  <span>Historical insights</span>
                </div>
                <div className="reference-bar"></div>
                <p className="reference-text">
                  Explore real-time water Bacteria testing with Citispring Bactest.   </p>
              </div>
            </div>
          ) : (
            <>
              {loading ? (
                <p>Loading average eLux data...</p>
              ) : deviceData ? (
                <>
                  <div className="info-layout">
                    <div
                      className={`detection-box ${
                        deviceData.progress !== "In Progress"
                          ? deviceData.bacteriaResult === "Safe"
                            ? "safe"
                            : "Unsafe"
                          : ""
                      }`}
                      style={
                        deviceData.progress === "In Progress"
                          ? { "--progress": progressPercentage }
                          : {}
                      }
                    >
                      {deviceData.progress === "In Progress" ? (
                        <h1>{progressPercentage}%</h1>
                      ) : (
                        <h1>{deviceData.bacteriaResult}</h1>
                      )}
                    </div>

                    <br />
                    <div className="info-panel">
                      <div className="info-box">
                        <img
                          src={bacteria}
                          alt="bacteria"
                          style={{ width: 24, marginBottom: 4 }}
                        />
                        <span>Bacterial content</span>
                        <span className="value">
                          {Math.max(
                            0,
                            (3200 - deviceData.averageELux.toFixed(2)).toFixed(0)
                          )}
                        </span>
                      </div>
                      <div className="info-box">
                        <img
                          src={time}
                          alt="clock"
                          style={{ width: 24, marginBottom: 4 }}
                        />
                        <span>Detection Date</span>
                        <span className="value">
                          {formatDate(deviceData.timestamp)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div className="info-layout">
                    <div className="reference-container">
                      <h4>Reference Standard for Bacterial Content</h4>
                      <div className="reference-labels">
                        <span>&lt;1400 Clean</span>
                        <span>1400 - 2200 Low Risk</span>
                        <span>&gt;2600 High Risk</span>
                      </div>
                      <div className="reference-bar"></div>
                      <p className="reference-text">
                        Reference standard: "Drinking Water Hygiene Standard"
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                <p>No data available for this device.</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerHello;
